export {default as canvasLogo} from './canvas.svg';
export {default as cleverLogo} from './clever.svg';
export {default as googleClassroomLogo} from './google.svg';
export {default as schoologyLogo} from './schoology.svg';
